/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Additionalinfo1Inputs */

const en__field_additionalinfo1 = /** @type {(inputs: _Field_Additionalinfo1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`additional Information`)
};

const de__field_additionalinfo1 = /** @type {(inputs: _Field_Additionalinfo1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`weitere Infos`)
};

/**
* | output |
* | --- |
* | "additional Information" |
*
* @param {_Field_Additionalinfo1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_additionalinfo1 = /** @type {((inputs?: _Field_Additionalinfo1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Additionalinfo1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_additionalinfo1(inputs)
	return de__field_additionalinfo1(inputs)
});
export { _field_additionalinfo1 as "_field_additionalInfo" }